import { createSlice } from "@reduxjs/toolkit";
import { getRewardsProducts } from "store/actions/Reward.action";

const initialLog = {
  type: "",
  error: false,
  message: null,
  loading: false,
  success: false,
};

const initialState = {
  loading: false,
  success: false,
  message: null,
  error: false,
  isOpenRedeemModal: false,

  rewardsProductsData: [],
  rewardsProductsDataRaw: null,
  logs: initialLog,
};

const slice = createSlice({
  name: "Reward",
  initialState,
  reducers: {
    openRedeemModal: (state, action) => {
      state.isOpenRedeemModal = action.payload;
    },
    clearState: (state, action) => {
      state.error = false;
      state.success = false;
      state.message = null;
    },
    resetState: (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = false;
      state.message = null;
      state.isOpenRedeemModal = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRewardsProducts.pending, (state) => {
        state.logs = {
          ...initialLog,
          loading: true,
          type: "getRewardsProducts",
        };
      })
      .addCase(getRewardsProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.rewardsProductsDataRaw = action.payload;
        state.success = true;
        state.error = false;
        state.getProductsLoading = false;
        state.rewardsProductsData = action.payload.d;
        state.logs = { ...state.logs, success: true, loading: false };
      })
      .addCase(getRewardsProducts.rejected, (state, action) => {
        state.loading = false;
        state.data = null;
        state.success = false;
        state.error = true;
        state.message = action.payload?.m;
        state.getProductsLoading = false;
        state.logs = {
          ...state.logs,
          loading: false,
          error: action?.payload?.errors,
          message:
            action.payload?.m ||
            "Something went wrong getting rewards products.",
        };
      });
  },
});

export const openRedeemModal = (payload) => (dispatch) => {
  dispatch(slice.actions.openRedeemModal(payload));
};

export const clearState = (payload) => (dispatch) => {
  dispatch(slice.actions.clearState(payload));
};

export const resetRewardState = () => (dispatch) => {
  dispatch(slice.actions.resetState());
};

export const { reducer: Reward } = slice;

export default slice;
